import * as React from "react";
type Props = {
  fill: string;
  width: number;
  height: number;
};
function HeartFilledSvg(props: Props) {
  const { fill, width = 12, height = 12 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none">
      <path
        d="M8.25 1.5C7.82297 1.49882 7.40074 1.59012 7.01235 1.76762C6.62395 1.94512 6.27859 2.2046 6 2.52825C5.72141 2.2046 5.37605 1.94512 4.98765 1.76762C4.59926 1.59012 4.17703 1.49882 3.75 1.5C3.16094 1.50091 2.58519 1.67522 2.09454 2.00118C1.6039 2.32715 1.22007 2.79034 0.990928 3.333C0.761787 3.87566 0.697473 4.47378 0.806007 5.05275C0.91454 5.63172 1.19112 6.16593 1.60125 6.58875L5.73225 10.8105C5.76716 10.8461 5.80882 10.8744 5.85479 10.8937C5.90077 10.913 5.95013 10.923 6 10.923C6.05005 10.923 6.09959 10.913 6.1457 10.8935C6.19181 10.8741 6.23357 10.8456 6.2685 10.8098L10.2547 6.71925C10.7065 6.31472 11.0247 5.78242 11.167 5.19293C11.3093 4.60344 11.2691 3.98462 11.0516 3.41852C10.8342 2.85242 10.4498 2.36578 9.94946 2.02315C9.4491 1.68052 8.85642 1.49807 8.25 1.5Z"
        fill={fill}
      />
    </svg>
  );
}

export default HeartFilledSvg;
